const initialState = [];

export const dmaCodes = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_ZIP_DMA_CODE_RESULT':
      return action.payload;
    default:
      return state;
  }
};
